/* tslint:disable:max-line-length */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import {
  IDistribucionFondo,
  IInstrumentoInversion,
  IRentabilidad,
} from '../Entities/traslado.entities';
import { getFullRut, getPureRut, getLocalStorage } from '../helpers/helper';
import { key_user_info } from '../helpers/constants';

@Injectable({
  providedIn: 'root',
})
export class TrasladoService {
  constructor(private http: HttpClient) {}

  getDistribucionActual(idPoliza: any): Observable<IDistribucionFondo[]> {
    const userInfo = getLocalStorage(key_user_info);
    const usuario = getFullRut(userInfo.rut);
    return this.http
      .get<any>(
        `${environment.url.api}/ind/Polizas/Traslados/ListarDistribucionCuenta/${idPoliza}/${usuario}`
      )
      .pipe(
        map(data => {
          if (!data) {
            return null;
          }

          const dis = data.Distribucion as IDistribucionFondo[];

          return dis.map(d => {
            d.Participacion = d.SaldoInstrumento / d.SaldoCuenta;
            return d;
          });
        })
      );
  }

  verificarPassword(clave: string): Observable<number> {
    const userInfo = getLocalStorage(key_user_info);
    const rut = getFullRut(userInfo.rut);
    const usuario = getPureRut(userInfo.rut);
    const body = {
      Datos: {
        rut,
        clave,
        usuario,
      },
    };
    return this.http.post<number>(
      `${environment.url.api}/ind/Polizas/Posttraslados/ValidarClave/`,
      body
    );
  }

  getInstrumentoInversion(idPoliza: any): Observable<IInstrumentoInversion[]> {
    const userInfo = getLocalStorage(key_user_info);
    const rut = getFullRut(userInfo.rut);
    return this.http
      .get<any>(
        `${environment.url.api}/ind/Polizas/Traslados/ListarInstrumentosInversion/${idPoliza}/${rut}`
      )
      .pipe(
        map(data => {
          if (!data) {
            return null;
          }
          return data.InstrumentoInversion;
        })
      );
  }

  getRentabilidad(
    idPoliza: any,
    codigoSerie: string,
    periodo?: string,
    fechaInicio?: string,
    fechaFin?: string
  ): Observable<IRentabilidad> {
    const userInfo = getLocalStorage(key_user_info);
    const rut = getFullRut(userInfo.rut);
    return this.http
      .get<any>(
        `${environment.url.api}/ind/Polizas/Rentabilidades/ListarRentabilidadAlternativa/${idPoliza}/${codigoSerie}/${periodo}/${fechaInicio}/${fechaFin}/NAV/${rut}`
      )
      .pipe(
        map(data => {
          if (!data) {
            return null;
          }
          return data.Rentabilidad[data.Rentabilidad.length - 1];
        })
      );
  }

  getMaxTotal(idPoliza: any): Observable<number> {
    const userInfo = getLocalStorage(key_user_info);
    const rut = getFullRut(userInfo.rut);
    return this.http.get<any>(
      `${environment.url.api}/ind/Polizas/Traslados/ValidarAccedeMaxTotal/${idPoliza}/${rut}`
    );
  }

  getSolicitudPendientes(idPoliza: any) {
    const userInfo = getLocalStorage(key_user_info);
    const rut = getFullRut(userInfo.rut);
    return this.http.get<any>(
      `${environment.url.api}/ind/Polizas/Traslados/ValidarExisteSolicitudPendiente/${idPoliza}/${rut}`
    );
  }

  cancelarSolicitudPendiente(idPoliza: any, valorPoliza: number, folio: any) {
    const userInfo = getLocalStorage(key_user_info);
    const rut = getFullRut(userInfo.rut);
    return this.http.get<any>(
      `${environment.url.api}/ind/Polizas/Traslados/CancelarSolicitudPendiente/${idPoliza}/${folio}/${valorPoliza}/${rut}`
    );
  }

  generarTraslado(
    poliza: any,
    distribucion: IDistribucionFondo[]
  ): Observable<any> {
    const userInfo = getLocalStorage(key_user_info);
    const usuario = getFullRut(userInfo.rut);

    let detalleCompra = '';

    distribucion.forEach(d => {
      detalleCompra += `${detalleCompra ? '|' : ''}${
        d.CodigoSerie
      };${Math.round(d.SaldoInstrumento)};${d.Participacion}`;
    });

    const body = {
      Traslado: {
        poliza,
        usuario,
        detalleCompra,
      },
    };
    return this.http.post<any>(
      `${environment.url.api}/ind/Polizas/Posttraslados/GenerarTrasladoFondo/`,
      body
    );
  }

  enviarComprobanteCambioFondo(idPoliza: any, folio: any): Observable<any> {
    const userInfo = getLocalStorage(key_user_info);
    const usuario = getFullRut(userInfo.rut);
    return this.http.get<any>(
      `${environment.url.api}/ind/Polizas/Traslados/EnviarComprobante/${idPoliza}/${folio}/${usuario}`
    );
  }

  getDistribucionProceso(
    idPoliza: any,
    folio: any
  ): Observable<IDistribucionFondo[]> {
    const userInfo = getLocalStorage(key_user_info);
    const usuario = getFullRut(userInfo.rut);
    return this.http
      .get<any>(
        `${environment.url.api}/ind/Polizas/Traslados/EnCurso/${idPoliza}/${folio}/${usuario}`
      )
      .pipe(
        map(data => {
          if (!data) {
            return null;
          }
          return data.DistribucionEnCurso;
        })
      );
  }
}
